<div class="new-reservation-container">
  <app-expansion-panel [opened]="true" [close]="closePanelObservable">
    <app-expansion-panel-header>Faça uma nova reserva</app-expansion-panel-header>
    <app-expansion-panel-body>
      <app-flights-form [form]="flightsForm" (onSubmit)="searchFlights()" (filled)="getFlights()">
      </app-flights-form>
    </app-expansion-panel-body>
  </app-expansion-panel>

  @if (showChooseFlight && outboundFlightsxc) {
    <app-choose-flight [direction]="Direction.OUTBOUND" [flightsFormData]="flightsFormData"
      [flights]="outboundFlightsxc" [form]="chooseFlightForm"
      [proceeded]="proceeded">
    </app-choose-flight>
    @if (flightsFormData.isRoundTrip() && inboundFlightsxc) {
      <app-choose-flight [direction]="Direction.INBOUND" [flightsFormData]="flightsFormData"
        [flights]="inboundFlightsxc" [form]="chooseFlightForm"
        [proceeded]="proceeded">
      </app-choose-flight>
    }
    <div class="btn-proceed-container">
      <button class="btn-proceed" type="button" [disabled]="flightsRequestStatus.isError" (click)="proceedReservation()">
        Prosseguir
      </button>
    </div>
  }

  @if (!showChooseFlight) {
    <div class="my-4">
      @if (flightsRequestStatus.isLoading) {
        <app-loading></app-loading>
      }
      @if (flightsRequestStatus.isError && flightsRequestStatus.getErrorMessage()) {
        <div >
          ⚠️{{ flightsRequestStatus.getErrorMessage() }}
        </div>
      }
      @if (flightsRequestStatus.isNone && flightsIsEmpty()) {
        <div >
          ⚠️ Não há voos disponíveis para origem/destino e período indicados.
        </div>
      }
    </div>
  }
</div>